import { ShieldAlert, Phone } from "lucide-react";

interface AiChatDisclaimerProps {
  variant: "nurse" | "patient" | "ot";
}

export function AiChatDisclaimer({ variant }: AiChatDisclaimerProps) {
  if (variant === "nurse") {
    return (
      <div className="flex items-start gap-3 bg-teal-50 border border-teal-200 rounded-xl px-4 py-3 text-sm text-teal-900">
        <ShieldAlert className="h-4 w-4 text-teal-600 shrink-0 mt-0.5" />
        <p>
          <strong>Clinical Decision Support Only.</strong> This AI assistant supports evidence-based practice grounded in NMC Code, NICE, BSR, and EULAR guidelines. It does not replace your professional judgment or NMC accountability. All clinical decisions remain your sole responsibility as a registered nurse. Do not use AI responses as the basis for individual patient care without clinical review.
        </p>
      </div>
    );
  }

  if (variant === "ot") {
    return (
      <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-sm text-amber-900">
        <ShieldAlert className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
        <p>
          <strong>OT Clinical Decision Support Only.</strong> This AI assistant is grounded in RCOT Code of Ethics and Professional Conduct, NICE guidelines (NG100, NG206, NG65), COT Fatigue Management Programme, and evidence-based rheumatology OT practice. It does not replace your professional judgment or HCPC accountability. All OT assessments and interventions remain your professional responsibility. Do not apply AI guidance to individual patients without full clinical assessment.
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-sm text-amber-900">
      <ShieldAlert className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
      <p>
        <strong>Important:</strong> This AI guide provides general health information only. It cannot diagnose conditions, prescribe medication, or replace advice from your healthcare team. Always consult your rheumatology nurse or GP for medical decisions.{" "}
        <a href="tel:999" className="font-semibold underline">999</a> for emergencies &middot;{" "}
        <a href="tel:111" className="font-semibold underline">NHS 111</a> for urgent advice.
      </p>
    </div>
  );
}
